export enum SpecialUomCode {
    FeetInch16 = 'I16',
    Percentage = 'P1'
}
